/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_Error_Not_AllowedInputs */

const en_dictation_error_not_allowed = /** @type {(inputs: Dictation_Error_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microphone permission denied`)
};

const pt_br2_dictation_error_not_allowed = /** @type {(inputs: Dictation_Error_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissão de microfone negada`)
};

/**
* | output |
* | --- |
* | "Microphone permission denied" |
*
* @param {Dictation_Error_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_error_not_allowed = /** @type {((inputs?: Dictation_Error_Not_AllowedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_Error_Not_AllowedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_error_not_allowed(inputs)
	return pt_br2_dictation_error_not_allowed(inputs)
});